import { useEffect } from 'react';
import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { Bas, IncomeEntityIndex } from '@funnels/types';
import { Accordion, AccordionGroup, FunnelGrid, FunnelGridUnit } from '@funnels/ui-components/Common';
import { BusinessBAS, BusinessGross } from '@funnels/ui-components/Income';

interface BusinessLowDocIncomeProps extends IncomeEntityIndex {}

export const BusinessLowDocIncome = (props: BusinessLowDocIncomeProps) => {
  const { incomeIndex } = props;
  const [formValues, setFormValue] = useFormValues();
  const bases: Bas[] = get(formValues, FIELD_PATHS.INCOME_BUSINESS_BASES(incomeIndex), []);

  useEffect(() => {
    if (!bases.length) {
      setFormValue(
        FIELD_PATHS.INCOME_BUSINESS_BASES(incomeIndex),
        [1, 2, 3, 4].map((quarter) => ({ quarter }))
      );
    }
  }, [bases.length, incomeIndex, setFormValue]);

  return (
    <FunnelGridUnit>
      <AccordionGroup>
        <Accordion headerText="Taxable income">
          <FunnelGrid>
            <FunnelGridUnit my="md">
              <BusinessGross incomeIndex={incomeIndex} hasLabel isOptional />
            </FunnelGridUnit>
            {[0, 1, 2, 3].map((quarter) => (
              <FunnelGridUnit mb="md" key={`BAS-quarter-${quarter}`}>
                <BusinessBAS incomeIndex={incomeIndex} quarter={quarter} hasLabel isOptional />
              </FunnelGridUnit>
            ))}
          </FunnelGrid>
        </Accordion>
      </AccordionGroup>
    </FunnelGridUnit>
  );
};
